import React from 'react';

import { Grid, TextField, ConfirmDialog, Typography } from '@gogame/components';

const PrefillFieldsDialog = ({
  children,
  controls,
  title,
  filedLabel,
  open,
  onSubmit,
  onExited,
  onClose,
  id,
  onChangeId,
  disabledConfirmAction,
  error,
}) => {
  return (
    <ConfirmDialog
      title={'Prefill fields from'}
      confirmActionLabel={'Prefill'}
      disabledConfirmAction={disabledConfirmAction}
      onSubmit={onSubmit}
      onExited={onExited}
      onClose={onClose}
      open={open}
      width={'400px'}
    >
      <Grid container direction={'column'} spacing={2}>
        {controls ? <Grid item>{controls}</Grid> : null}
        <Grid item>
          <Typography color={'textSecondary'}>{title}</Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            value={id}
            onChange={onChangeId}
            label={filedLabel}
            loading={true}
            fullWidth={true}
            debounceTimeout={500}
            error={error}
            autoFocus={true}
          />
        </Grid>
        <Grid item xs={12}>
          {children}
        </Grid>
      </Grid>
    </ConfirmDialog>
  );
};

export default PrefillFieldsDialog;
